// extracted by mini-css-extract-plugin
module.exports = {"shadow":"CardWrapper_shadow__2KHOe","errUnknownCardType":"CardWrapper_errUnknownCardType__KwrNt global_cardHover__VD7I6"};